<script setup lang="ts">
import { computed } from "vue";

import type { JsonArticleComponentProps } from "@/types/components/json-article-component.type";

import LeArticleBody from "./LeArticleBody.vue";
import LeArticleHeader from "./LeArticleHeader.vue";
import type { ClausensArticle } from "./types";

const {
  article,
  isCompactArticleExpanded = false,
  searchViewType
} = defineProps<JsonArticleComponentProps<ClausensArticle>>();

const isCompactSearchView = computed<boolean>(() => searchViewType === "compact");

const hasBody = computed<boolean>(() => article.meanings.length > 0);
</script>

<template>
  <article class="le-article">
    <LeArticleHeader
      class="le-article__header"
      :class="{ 'le-article__header--no-body': !hasBody }"
      :article="article"
      :collapsible="isCompactSearchView"
    >
      <template #dictionaryCover>
        <slot name="dictionaryCover" />
      </template>
      <template #link="slotProps">
        <slot name="link" v-bind="slotProps" />
      </template>
      <template #feedbackButton>
        <slot name="feedbackButton" />
      </template>
      <template #aboutDictionaryButton>
        <slot name="aboutDictionaryButton" />
      </template>
    </LeArticleHeader>
    <LeArticleBody
      v-if="hasBody"
      :article="article"
      :collapsible="isCompactSearchView"
      :expanded="isCompactArticleExpanded"
    >
      <template #compactExpandButton="slotProps">
        <slot v-if="isCompactSearchView" name="compactExpandButton" v-bind="slotProps" />
      </template>
      <template #link="slotProps">
        <slot name="link" v-bind="slotProps" />
      </template>
    </LeArticleBody>
    <slot v-if="isCompactSearchView" name="compactFooter" />
  </article>
</template>

<style lang="less">
@import "../style/le-article";

.le-article {
  font-family: "Open SansVariable", sans-serif;
}
</style>
